import { BlockConfig, zeroIOPS } from "../block-base";

export const arrowConfig: BlockConfig = {
  displayName: "Arrow",
  imagePath: "",
  isInitiator: false,
  isTerminator: false,
  isInterceptor: false,
  hasSettings: true, // Allows user to configure the direction (Up, Right, Down, Left)
  allowedInputTypes: new Set(),
  allowedOutputTypes: new Set(),
  inputCapacity: zeroIOPS(),
  processingCapacity: zeroIOPS(),
  purchasePrice: 0,
  sellPrice: 0,
  costPerCycle: 0,
  outputConnectorLimits: {},
};
